/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _call_super = require("@swc/helpers/_/_call_super");
var _class_call_check = require("@swc/helpers/_/_class_call_check");
var _create_class = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var Hook = require("./Hook");
var HookCodeFactory = require("./HookCodeFactory");
var AsyncSeriesLoopHookCodeFactory = /*#__PURE__*/ function(HookCodeFactory) {
    _inherits._(AsyncSeriesLoopHookCodeFactory, HookCodeFactory);
    function AsyncSeriesLoopHookCodeFactory() {
        _class_call_check._(this, AsyncSeriesLoopHookCodeFactory);
        return _call_super._(this, AsyncSeriesLoopHookCodeFactory, arguments);
    }
    _create_class._(AsyncSeriesLoopHookCodeFactory, [
        {
            key: "content",
            value: function content(param) {
                var onError = param.onError, onDone = param.onDone;
                return this.callTapsLooping({
                    onError: (i, err, next, doneBreak)=>onError(err) + doneBreak(true),
                    onDone
                });
            }
        }
    ]);
    return AsyncSeriesLoopHookCodeFactory;
}(HookCodeFactory);
var factory = new AsyncSeriesLoopHookCodeFactory();
function COMPILE(options) {
    factory.setup(this, options);
    return factory.create(options);
}
function AsyncSeriesLoopHook() {
    var args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
    var hook = new Hook(args, name);
    hook.constructor = AsyncSeriesLoopHook;
    hook.compile = COMPILE;
    hook._call = undefined;
    hook.call = undefined;
    return hook;
}
AsyncSeriesLoopHook.prototype = null;
module.exports = AsyncSeriesLoopHook;
